<template>
  <!-- back button -->
  <div
    class="content-back-button pt-3 pb-3"
    v-if="active_key > 0 && active_key < 4"
    @click="decNext"
    :disabled="backDisabled"
    ref="backBtn"
  >
    <a href="javascript:void(0);"
      ><svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-chevron-left"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
        /></svg
      ><small>Previous</small>
    </a>
  </div>
  <!-- end back button -->
</template>
<script>
import { navigation } from "@/mixins/navigation";
export default {
  mixins: [navigation],
  props: ["backDisabled", "active_key", "active_index", "issues"],
  data() {
    return {};
  },
  computed: {
    cls: function () {
      if (this.active_key > 0 && this.active_key < 4) {
        return "component in";
      } else {
        return "component out";
      }
    },
  },
};
</script>
